import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import {
  DiscussionParticipantsCreateRequestDTO,
  DiscussionParticipantsDeleteRequestDTO,
  DiscussionParticipantsDTO,
  DiscussionParticipantsList,
  DiscussionParticipantsReadByDiscussionIdRequestDTO,
  DiscussionParticipantsReadByIdRequestDTO,
  DiscussionParticipantsReadByUserIdRequestDTO,
  DiscussionParticipantsUpdateRequestDTO,
} from "./discussion-participants.interface";
import {
  DiscussionParticipants_Create,
  DiscussionParticipants_Delete,
  DiscussionParticipants_ReadAll,
  DiscussionParticipants_ReadByDiscussionId,
  DiscussionParticipants_ReadById,
  DiscussionParticipants_ReadByUserId,
  DiscussionParticipants_Update,
} from "src/app/GlobalVariable";

@Injectable({
  providedIn: "root",
})
export class DiscussionParticipantsService {
  private http = inject(HttpClient);

  DiscussionParticipants_Create(
    data: DiscussionParticipantsCreateRequestDTO,
  ): Observable<DiscussionParticipantsDTO> {
    return this.http.post<DiscussionParticipantsDTO>(
      DiscussionParticipants_Create,
      data,
    );
  }

  DiscussionParticipants_Update(
    data: DiscussionParticipantsUpdateRequestDTO,
  ): Observable<DiscussionParticipantsDTO> {
    return this.http.post<DiscussionParticipantsDTO>(
      DiscussionParticipants_Update,
      data,
    );
  }

  DiscussionParticipants_ReadAll(): Observable<DiscussionParticipantsList> {
    return this.http.get<DiscussionParticipantsList>(
      DiscussionParticipants_ReadAll,
    );
  }

  DiscussionParticipants_Delete(
    data: DiscussionParticipantsDeleteRequestDTO,
  ): Observable<void> {
    return this.http.post<void>(DiscussionParticipants_Delete, data);
  }

  DiscussionParticipants_ReadById(
    data: DiscussionParticipantsReadByIdRequestDTO,
  ): Observable<DiscussionParticipantsDTO> {
    return this.http.post<DiscussionParticipantsDTO>(
      DiscussionParticipants_ReadById,
      data,
    );
  }

  DiscussionParticipants_ReadByDiscussionId(
    data: DiscussionParticipantsReadByDiscussionIdRequestDTO,
  ): Observable<DiscussionParticipantsList> {
    return this.http.post<DiscussionParticipantsList>(
      DiscussionParticipants_ReadByDiscussionId,
      data,
    );
  }

  DiscussionParticipants_ReadByUserId(
    data: DiscussionParticipantsReadByUserIdRequestDTO,
  ): Observable<DiscussionParticipantsList> {
    return this.http.post<DiscussionParticipantsList>(
      DiscussionParticipants_ReadByUserId,
      data,
    );
  }
}
